<template>
	<div class="sections">
		<section>
			<h3>Monatsgehalt auf Basis Vollzeit</h3>
			<p>Bandbreite je nach Erfahrung / Ausbildung / Kompetenz</p>
			<SalaryEdit
				v-model="salary"
				range
				with-calculator-link
				class="mt-2"
				@input="emitChangeEvent"
			/>
		</section>
		<section>
			<h3>Mindestgehalt</h3>
			<p>
				Wichtig: In bestimmten Ländern (z.B. Österreich) muss laut Gesetz das Mindestgehalt eines Jobs angegeben
				werden, unabhängig davon, ob das tatsächlich bezahlte Gehalt darüber liegt.
			</p>
			<SalaryEdit
				v-model="salaryCollective"
				for-collective
				:with-calculator-link="false"
				class="mt-2"
				@input="emitChangeEvent"
			/>
		</section>
	</div>
</template>

<script>
import {isDefined} from "@/helper/Value";
import SalaryEdit from "@/vue/common/salary/Edit";

export default {

	components: {
		SalaryEdit,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			salary: this.value?.salary,
			salaryCollective: this.value?.salaryCollective,
		};
	},

	computed: {
		dataValid ()
		{
			return isDefined(this.salary) && isDefined(this.salaryCollective);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);

				return;
			}

			this.$emit('input', {
				salary: this.salary,
				salaryCollective: this.salaryCollective,
			});
		}
	}
}
</script>
